import axios from 'axios';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://quiz.rettungjim.org/backend/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Refresh token on 401 once per request
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/auth/refresh')
    ) {
      originalRequest._retry = true;
      try {
        await api.post('/auth/refresh');
        return api(originalRequest);
      } catch (refreshError) {
        // Fallthrough to reject
      }
    }
    return Promise.reject(error);
  }
);

export default api;
